import { IHoleResult } from '../../admin/holeResults/store';

export interface IHoleResultsStore {
  [roundId: number]: IHoleResult[];
}

export const holeResultsStore: IHoleResultsStore = {};
